import { useState } from 'react';
import { useSelector } from 'react-redux';
import { USER_ROLES } from '../../../../utils/constants';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';

const useAssignRequest = () => {
    const userInfo = useSelector(state => state.auth.user);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const isValid = ({ fexecId, reqDetails }) => {
        if (!reqDetails) {
            return false;
        }
        if (!reqDetails.uniqueId) {
            return false;
        }
        const isAdmin = userInfo && userInfo.role && userInfo.role === USER_ROLES.SUPER_ADMIN;
        if (isAdmin && !fexecId) {
            return false;
        }

        return true;
    };

    const assignRequest = async ({ fexecId = '', reqDetails = null }) => {
        if (!isValid({ fexecId, reqDetails })) {
            return;
        }
        try {
            setLoading(true);
            const url = `${APIUtils.getAdminAPIEndpoint('exec-update-request')}/${reqDetails.uniqueId}`;
            const res = await httpClient.put(url, { status: 'ACCEPTED', fexecId }).then(res => res.data);
            if (res.status === 'success') {
                return { err: null, res };
            }
        } catch (error) {
            setError(error);
            return { err: error, res: null };
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, assignRequest };
};

export default useAssignRequest;